import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// ADMIN PANEL APIS
// ================================

// 🔹 Update Business Profile
export async function updateBusinessProfile(
  user_id,
  business_name,
  business_industry,
  business_punchline,
  business_about,
  business_primary,
  business_secondary,
  business_logo = null,
  business_fav = null
) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("business_name", business_name);
    fd.append("business_industry", business_industry);
    fd.append("business_punchline", business_punchline);
    fd.append("business_about", business_about);
    fd.append("business_primary", business_primary);
    fd.append("business_secondary", business_secondary);

    if (business_logo) fd.append("business_logo", business_logo);
    if (business_fav) fd.append("business_fav", business_fav);

    const response = await axios.post(`${apiBaseUrl}admin/business_profile_update`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateBusinessProfile error:", error);
    return { status: false, type: "danger", success: "Update failed" };
  }
}

// 🔹 Update Personal Profile
export async function updateProfile(user_id, fname, lname, email, mobile, avatar = null) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("fname", fname);
    fd.append("lname", lname);
    fd.append("email", email);
    fd.append("mobile", mobile);

    if (avatar) fd.append("avatar", avatar);

    const response = await axios.post(`${apiBaseUrl}admin/profile_update`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateProfile error:", error);
    return { status: false, type: "danger", success: "Profile update failed" };
  }
}

// 🔹 Change Password
export async function changePassword(user_id, old_pass, new_pass) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("old_pass", old_pass);
    fd.append("new_pass", new_pass);

    const response = await axios.post(`${apiBaseUrl}admin/change_pass`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("changePassword error:", error);
    return { status: false, type: "danger", success: "Password update failed" };
  }
}

// 🔹 Deactivate Account
export async function deactivateAccount(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}admin/deactive_acc`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deactivateAccount error:", error);
    return { status: false, type: "danger", success: "Account deactivation failed" };
  }
}

// 🔹 Add or Update Integration
export async function addIntegration(
  intigration_user,
  intigration_name,
  intigration_type,
  intigration_token1,
  intigration_token2,
  intigration_token3,
  intigration_token4,
  intigration_status,
  intigration_logo = null
) {
  try {
    const fd = new FormData();
    fd.append("intigration_user", intigration_user);
    fd.append("intigration_name", intigration_name);
    fd.append("intigration_type", intigration_type);
    fd.append("intigration_token1", intigration_token1);
    fd.append("intigration_token2", intigration_token2);
    fd.append("intigration_token3", intigration_token3);
    fd.append("intigration_token4", intigration_token4);
    fd.append("intigration_status", intigration_status);

    if (intigration_logo) fd.append("intigration_logo", intigration_logo);

    const response = await axios.post(`${apiBaseUrl}admin/add_intigration`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("addIntegration error:", error);
    return { status: false, type: "danger", success: "Failed to save integration" };
  }
}

// 🔹 Check Integration
export async function checkIntegration(intigration_user, intigration_name, intigration_type) {
  try {
    const fd = new FormData();
    fd.append("intigration_user", intigration_user);
    fd.append("intigration_name", intigration_name);
    fd.append("intigration_type", intigration_type);

    const response = await axios.post(`${apiBaseUrl}admin/check_intigration`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("checkIntegration error:", error);
    return { status: false, type: "danger", success: "Failed to check integration" };
  }
}

// 🔹 Get Templates List
export async function getTemplates(temp_user, page_no = 0, temp_type = "", temp_cat = "", search_key = "") {
  try {
    const fd = new FormData();
    fd.append("temp_user", temp_user);
    fd.append("page_no", page_no);
    fd.append("temp_type", temp_type);
    fd.append("temp_cat", temp_cat);
    fd.append("search_key", search_key);

    const response = await axios.post(`${apiBaseUrl}admin/get_templetes`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getTemplates error:", error);
    return { status: false, type: "danger", success: "Failed to load templates" };
  }
}

// 🔹 Create or Update Template
export async function createTemplate(tempData) {
  try {
    const fd = new FormData();
    fd.append("temp_data", btoa(JSON.stringify(tempData)));

    const response = await axios.post(`${apiBaseUrl}admin/create_temp`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("createTemplate error:", error);
    return { status: false, type: "danger", success: "Failed to save template" };
  }
}

// 🔹 Delete Template
export async function deleteTemplate(temp_id) {
  try {
    const fd = new FormData();
    fd.append("temp_id", temp_id);

    const response = await axios.post(`${apiBaseUrl}admin/delete_temp`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteTemplate error:", error);
    return { status: false, type: "danger", success: "Failed to delete template" };
  }
}

export async function getAnaReport(web_id, filter_val = "last_30_days", from = "", to = "",rtype="0") {
  try {
    const fd = new FormData();
    fd.append("web_id", web_id);
    fd.append("filter_val", filter_val);
    fd.append("rtype", rtype);
    if (filter_val === "custom") {
      fd.append("from", from);
      fd.append("to", to);
    }

    const response = await axios.post(`${apiBaseUrl}ana_report/get_ana_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getAnaReport error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to fetch analytics report",
      report_dt: {},
    };
  }
}
